import { render, staticRenderFns } from "./addContact.vue?vue&type=template&id=5afd402f&scoped=true"
import script from "./addContact.vue?vue&type=script&lang=js"
export * from "./addContact.vue?vue&type=script&lang=js"
import style0 from "./addContact.vue?vue&type=style&index=0&id=5afd402f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afd402f",
  null
  
)

export default component.exports